import { FC, PropsWithChildren } from 'react';
import cx from 'classnames';
import styles from './header-search-bar-suggestions-column.module.scss';
import { Conditional } from '../../../common';

type HeaderSearchBarSuggestionsColumnProps = {
  className?: string;
  displayColumn?: boolean;
};

export const HeaderSearchBarSuggestionsColumn: FC<
  PropsWithChildren<HeaderSearchBarSuggestionsColumnProps>
> = ({ children, className, displayColumn = true }) => (
  <Conditional test={displayColumn}>
    <div
      className={cx(
        styles['header-search-bar-suggestions-column'],
        className ? className : ''
      )}
      data-testid="header-searchbar-suggestions-column"
    >
      {children}
    </div>
  </Conditional>
);
